import React from 'react';
import ReactModal from 'react-modal';

import styles from './promptModal.module.scss';

interface Props {
  isOpen: boolean;
  onRequestClose: () => void;
  children: JSX.Element;
  title?: string;
}

const PromptModal = ({ isOpen, onRequestClose, title, children }: Props) => {
  function afterOpenModal() {
    window?.scrollTo(0, 0);
  }

  return (
    <ReactModal
      onRequestClose={onRequestClose}
      onAfterOpen={afterOpenModal}
      isOpen={isOpen}
      className={{
        base: '',
        afterOpen: '',
        beforeClose: '',
      }}
      overlayClassName={{
        base: styles.modalOverlay,
        afterOpen: '',
        beforeClose: '',
      }}
      shouldCloseOnOverlayClick
    >
      <div className={styles.container}>
        {title && <p className={styles.title}>{title}</p>}
        <div className={styles.content}>{children}</div>
      </div>
    </ReactModal>
  );
};

export default PromptModal;
